import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessAnnouncementDetailContainer} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessAnnouncementDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessAnnouncementDetailPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessAnnouncementDetailContainer params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessAnnouncementDetailPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessAnnouncementDetailPage.jsx